import { useCallback } from 'react';

import { AppModel, useDeleteApp } from '../../../../modules/Apps';
import { ConfirmationDialog } from '../../../common/ConfirmationDialog';
import { useToastNotification } from '../../../common/Toaster';

interface DeleteAppDialogProps {
  isOpen: boolean;
  handleClose: VoidFunction;
  app: AppModel;
}
export function DeleteAppDialog({ isOpen, handleClose, app: { appId } }: DeleteAppDialogProps) {
  const { mutateAsync, isPending } = useDeleteApp();
  const toaster = useToastNotification();

  const deactivateApp = useCallback(async () => {
    try {
      await mutateAsync(appId);
      toaster.showSuccess('Application was successfully deleted!');
      handleClose();
    } catch (error) {
      toaster.showError('There was an error deleting the application. Please, try again later.');
    }
  }, [mutateAsync, appId, toaster, handleClose]);

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      confirmButtonLabel="Delete"
      heading="Delete Application"
      text="Are you sure you want to delete this Application?"
      handleConfirm={deactivateApp}
      handleDismiss={handleClose}
      destructive
      isConfirmDisabled={isPending}
    ></ConfirmationDialog>
  );
}
